import React, { useEffect } from 'react';

const WIDGET_EMBED_URL =
  'https://eodhljnwmkphervhvhio.supabase.co/functions/v1/widget-embed?widgetId=fb567272-c3db-4bf3-aba3-a2fc9d4e99ed&src=four_';

const SCRIPT_ID = 'pesquisa-marca-indecx-embed';

export default function PesquisaMarcaIndecx() {
  useEffect(() => {
    const isDesktop = window.screen.width >= 620;
    if (!isDesktop) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = WIDGET_EMBED_URL;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById(SCRIPT_ID);
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    };
  }, []);

  return null;
}
